import TikTokConnectButton from '../../Tiktok/TikTokConnectButton';
import TikTokDisconnectButton from '../../Tiktok/TikTokDisconnectButton';
import TikTokSettings from '../../Tiktok/TikTokSettings';

const SettingsTabTikTok = ({ tiktokAccount, setTiktokAccount, handleChange }) => {
  return (
    <>
      {tiktokAccount ? (
        <>
          <TikTokSettings tiktokAccount={tiktokAccount} handleChange={handleChange} />
          <TikTokDisconnectButton setTiktokAccount={setTiktokAccount} />
        </>
      ) : (
        <TikTokConnectButton />
      )}
    </>
  );
};

export default SettingsTabTikTok;
